import { addDays, isToday, isTomorrow, format } from 'date-fns';

export const generateAvailableDates = (
  filterDate,
  minDate,
  count = 14,
  filterTime,
  timeIntervals
) => {
  const dates = [];
  const start = minDate || new Date();
  const maxScan = 90; // safety limit to avoid infinite loop
  let i = 0;
  while (dates.length < count && i < maxScan) {
    const candidate = addDays(start, i);
    if (!filterDate || filterDate(candidate)) {
      const slots = generateTimeSlots(candidate, filterTime, timeIntervals);
      if (slots.length > 0) {
        dates.push(candidate);
      }
    }
    i++;
  }
  return dates;
};

export const generateTimeSlots = (date, filterTime, timeIntervals = 60) => {
  const slots = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += timeIntervals) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const candidate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, mins);
    if (!filterTime || filterTime(candidate)) {
      slots.push(candidate);
    }
  }
  return slots;
};

export const getDateChipLabel = (date) => {
  if (isToday(date)) return { line1: 'Today', line2: format(date, 'EEE') };
  if (isTomorrow(date)) return { line1: 'Tomorrow', line2: format(date, 'EEE') };
  return { line1: format(date, 'EEE'), line2: format(date, 'MMM d') };
};

export const isSameDay = (a, b) => {
  if (!a || !b) return false;
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
};

export const isSameTime = (a, b) => {
  if (!a || !b) return false;
  return a.getTime() === b.getTime();
};
